module.exports = __webpack_public_path__ + "img/Logo_penascal_kooperativa-color.c7e9de2b.png";